<template>
  <div class="loginPage">
    <!-- header start -->
    <van-nav-bar 
      title="使用手机找回密码"
      class="mynavbar" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <!-- header end -->
    <img src="@/assets/images/login/register.jpg" class="loginBg">

    <div class="block pwd-block">
      <div>
        <div class="field-item">
          <div class="hd"><div class="label">手机号</div></div>
          <div class="bd"><van-field v-model="input.phone" placeholder="大陆手机号" disabled /></div>
          <div class="ft">
            <span v-if="!sendMsgDisabled" class="sendCode" @click="sendSms">发送</span>
            <span v-if="sendMsgDisabled" class="resendCode">{{codeTime}}</span>
          </div>
        </div>
        <div class="field-item">
          <div class="hd"><div class="label">验证码</div></div>
          <div class="bd"><van-field v-model="input.code" type="number" placeholder="请输入验证码" /></div>
        </div>
        <div class="field-item">
          <div class="hd"><div class="label">密码</div></div>
          <div class="bd"><van-field v-model="input.password" type="password" placeholder="请输入6-16位新密码" /></div>
        </div>
        <div class="btn-area">
          <van-button round  class="loginbtn" @click="loginsubmit">提交</van-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
 import {Toast} from 'vant';
  export default {
    data() {
      return {
        input:{
          phone:"",
          code:"",
          password:"",
          type:"ResetPassword",
        },
        codeTime: 59, // 发送验证码倒计时
        sendMsgDisabled: false, // 是否显示获取验证码按钮
      }
    }, 
    methods :{
      onClickLeft() {
        this.$router.go(-1)
      },
      countDown(){
        var _this = this;
        _this.sendMsgDisabled = true;
        let codeInterval = window.setInterval(function() {
            if ((_this.codeTime--) <= 0) {
                  _this.codeTime = 59;
                  _this.sendMsgDisabled = false;
                  window.clearInterval(codeInterval);
              }
          }, 1000);
      },
      sendSms(){
        var that = this;
        var regPhone = /^1[0-9]{10}$/;
        if (that.input.phone == "") {
            Toast("未获取到手机号");
            return false;
        } else if (!regPhone.test(that.input.phone)) {
            Toast("手机号码不正确，请核对后再输入！");
            return false;
        }
        this.$store.dispatch({
          type:"GetSendSms",
          phone:that.input.phone,
        }).then(res => {
          if(res.IsSuccess){
            Toast("发送成功！");
            that.countDown();
          }
        }, err =>{})
      },
      loginsubmit(){
        var that = this;
        var regPhone = /^1[0-9]{10}$/;
        if (that.input.phone == "") {
            Toast("未获取到手机号");
            return false;
        } else if (!regPhone.test(that.input.phone)) {
            Toast("手机号码不正确，请核对后再输入！");
            return false;
        }
        if (that.input.code == ""){
          Toast("验证码不能为空");
          return false;
        }
        if (that.input.password.length < 6){
          Toast("密码不能少于6位");
          return;
        } else if (that.input.password.length > 16){
          Toast("密码不能大于16位");
          return false;
        }
        that.$store.dispatch(that.input).then(res => {
          Toast(res.Message);
          if(res.IsSuccess){
            that.$router.replace({path:'/login'}) 
          }
        }, err => {})


      }
    },
    created(){
      if(this.$route.params.phone){
        this.input.phone = this.$route.params.phone;
      }
      
    }
  }
</script>

<style scoped>
.pwd-block{
  margin-top: 20%;
}
.sendCode{
  margin-left: 20px;
  padding: 0 14px;
  font-size: 12px;
  color: orange;
  border-left: 1px solid rgba(255,255,255,.6);
}
.resendCode{
  margin-left: 20px;
  padding: 0 14px;
  font-size: 12px;
  color: white;
  border-left: 1px solid rgba(255,255,255,.6);
}
</style>
